import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setMobileHeader } from '@/stores/headerSlice'

export const useMobileHeader = (show: boolean): void => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setMobileHeader(show))
  }, [])
}
